import { useEffect, useRef, useState } from "react";

const REVEAL_OFFSET = 24;

/**
 * 顶栏滚动状态：离开页面顶部后进入收缩态（`scrolled`），
 * 同时把整页阅读进度写入返回 ref 元素的 CSS 变量 `--page-progress`（0–1），不触发重新渲染。
 */
export function useHeaderScroll<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      const y = window.scrollY;
      const distance = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      ref.current?.style.setProperty("--page-progress", Math.min(1, Math.max(0, y / distance)).toFixed(4));
      setScrolled(y > REVEAL_OFFSET);
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    return () => {
      window.removeEventListener("scroll", schedule);
      window.removeEventListener("resize", schedule);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, []);

  return { ref, scrolled };
}
